import "./Brand-slider.css";

const CLIENTS = [
  {
    name: "RajiFarm",
    url: "https://rajifarm.com/",
    logo: `https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://rajifarm.com/&size=128`,
  },
  {
    name: "WS Realtor",
    url: "https://wsrealtor.in/",
    logo: "/images/wsRealtorLogo-Du8iYeVR.jpeg",
  },
];

const Brandslider = () => (
  <section id="clients" className="clients section">
    <div className="container">
      <div className="clients__head reveal">
        <span className="eyebrow">Trusted partnerships</span>
        <h2 className="section-title">
          Clients we are <span className="grad">privileged</span> to serve.
        </h2>
        <p className="section-sub">
          Global enterprises and growth-stage startups trust Ant Fire Labs to build, scale and
          staff their most important digital products.
        </p>
      </div>

      <div className="clients__grid reveal">
        {CLIENTS.map((c) => (
          <a
            key={c.name}
            href={c.url}
            target="_blank"
            rel="noopener noreferrer"
            className="clients__card"
          >
            <img
              src={c.logo}
              alt={c.name}
              loading="lazy"
              onError={(e) => { e.target.style.display = "none"; }}
            />
            <span className="clients__card-name">{c.name}</span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Brandslider;
